import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import FullOverlay from 'lib/components/full-overlay'
import ClickOutside from 'lib/tags/click-outside'
import Close from 'lib/icons/close'
import Arrow from 'lib/icons/arrow'
import useModalHistory from 'lib/utils/use-modal-history'

const DEFAULT_STROKE_COLOR = '#222'

export default function SharedModal ({ isOpen, onClose, children, className = '', showCloseButton = true }) {
  useModalHistory(isOpen, onClose, `shared-modal-${className}`)

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  const onClickOutside = event => {
    event.stopPropagation()
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className='shared-modal-container'>
      <FullOverlay />
      <ClickOutside onClickOutside={onClickOutside}>
        <div className={`modal-popup${className ? ` ${className}` : ''}`}>
          {showCloseButton && (
            <div className='close-button-container'>
              {className === 'review-modal' ? (
                <div className='arrow-icon-container'>
                  <Arrow isMenu stroke={DEFAULT_STROKE_COLOR} dir='left' onClick={onClose} />
                </div>
              ) : (
                <Close style={{ background: '#fff' }} pathStyle={{ stroke: '#222' }} onClick={onClose} />
              )}
            </div>
          )}
          <div className='modal-content'>{children}</div>
        </div>
      </ClickOutside>
    </div>
  )
}

SharedModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  showCloseButton: PropTypes.bool
}
